import React, { useEffect, useState } from "react";

export default function RefundRequest() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => setLoading(false), 600);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <div
            className="modal fade modalCentered modal-refund-request"
            id="refund_request"
            tabIndex="-1"
            aria-hidden="true"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="header d-flex justify-content-between align-items-center px-3 py-2">
                        <div className="heading">Refund Request</div>
                        <span
                            className="icon-close icon-close-popup"
                            data-bs-dismiss="modal"
                            role="button"
                            aria-label="Close"
                        />
                    </div>

                    {loading ? (
                        <div className="modal-body text-center p-5">
                            <span className="loader" />
                        </div>
                    ) : (
                        <div className="modal-body text-center p-4">
                            <img
                                src="/images/section/success.svg"
                                alt="Success"
                                width="80"
                                height="80"
                                className="mb-3"
                            />
                            <h5 className="mb-2">Your refund request has been submitted</h5>
                            <p className="text-sm text-muted mb-0">
                                We’ve received your request and our support team will process it shortly.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
